import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveApp } from '@/lib/useActiveApp';

/**
 * Puts the active app in the browser tab title, so a tab full of MultiMagic
 * windows is readable. See docs/MULTI_APP_WORKSPACE.md §6.3.
 *
 * Home, About and the auth pages keep the SEO title from the Rails layout
 * (app/views/layouts/multi_magic.erb) — those are public and indexed, so
 * flattening them to the bare brand name would be a regression.
 */
export function DocumentTitle() {
  const { t } = useTranslation();
  const { activeApp, isWorkspace } = useActiveApp();
  const seoTitle = useRef(document.title);

  useEffect(() => {
    const titleKey = isWorkspace ? 'apps.workspace' : activeApp ? `apps.${activeApp}` : null;
    document.title = titleKey ? `${t(titleKey)} · MultiMagic` : seoTitle.current;
  }, [activeApp, isWorkspace, t]);

  return null;
}
